import { Component, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form, required } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { NaytettavaKirjaus } from '../kirjanpito.component'

import { NumberDate } from '@lemon/core/model/common'
import { DateService } from '@lemon/core/service/date.service'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { Asiakas, AsiakkaanMaksutapa } from 'app/_jaettu-lemonator/model/asiakas'
import { Kirjaus } from 'app/_jaettu-lemonator/model/kirjanpito'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'

export interface KirjausMuutaSuoriteperusteiseksiDialogData {
  naytettavaKirjaus: NaytettavaKirjaus
  maksutavat: AsiakkaanMaksutapa[]
  asiakas: Asiakas
}

export interface KirjausMuutaSuoriteperusteiseksiDialogReturnValue {
  muutettavaKirjaus: Kirjaus
  ostolaskuKirjauksenPaivamaara: NumberDate
}

interface SuoriteperusteLomake {
  kirjauksenPvm: Date | null
}

@Component({
  templateUrl: './kirjaus.muuta-suoriteperusteiseksi.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjausMuutaSuoriteperusteiseksiDialog implements OnInit {
  lomake: FieldTree<SuoriteperusteLomake>
  ensimmainenPaiva: Date = new Date(2015, 1, 1)
  viimeinenPaiva: Date = new Date()

  private _paivamaara: number = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KirjausMuutaSuoriteperusteiseksiDialogData,
    private _dialogRef: MatDialogRef<KirjausMuutaSuoriteperusteiseksiDialog, KirjausMuutaSuoriteperusteiseksiDialogReturnValue>,
    private _dateService: DateService,
    private _formValidationService: FormValidationService,
    private _asiakasJaettuService: AsiakasJaettuService,
  ) {
    this.lomake = form(signal<SuoriteperusteLomake>({ kirjauksenPvm: null }), polku => {
      required(polku.kirjauksenPvm)
    })
    arvonMuutokset(this.lomake.kirjauksenPvm).subscribe(value => {
      this._paivamaara = this._dateService.localDateToNumber(this._dateService.dateToLocalDate(value))
    })

    const ensimmainenTilikausi = this._asiakasJaettuService.annaEnsimmainenTilikausi(data.asiakas)
    if (ensimmainenTilikausi) {
      this.ensimmainenPaiva = this._dateService.localDateToDate(ensimmainenTilikausi.alkaa)
    }

    const viimeinenTilikausi = this._asiakasJaettuService.annaViimeinenTilikausi(data.asiakas)
    if (viimeinenTilikausi) {
      this.viimeinenPaiva = this._dateService.localDateToDate(viimeinenTilikausi.loppuu)
    }

    const kirjauksenPaivamaara = this.data.naytettavaKirjaus.uusiPaivamaara || this.data.naytettavaKirjaus.kirjaus.p
    const lastOfPreviousMonth = this._dateService.kuukaudenViimeinenNumber(this._dateService.lisaaKuukausiaNumero(kirjauksenPaivamaara, -1))
    const asDate = this._dateService.numberToDate(lastOfPreviousMonth)
    asetaArvo(this.lomake.kirjauksenPvm, asDate)
  }

  ngOnInit() {}

  kopioi() {
    if (this.lomake().invalid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }

    this._dialogRef.close({ muutettavaKirjaus: this.data.naytettavaKirjaus.kirjaus, ostolaskuKirjauksenPaivamaara: this._paivamaara })
  }
}
